module.exports = __webpack_public_path__ + "static/media/workbench.34710c55.webp";